<div class="limiter">
  <app-toaster-container></app-toaster-container>
  <div class="container-login100">
    <div class="wrap-login100">
      <div class="login100-form validate-form">
        <div class="Frame11" style="flex-direction: column; gap: 2vh; display: flex">
          <div class="Frame54"
            style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
            <div class="Frame7"
              style="align-self: stretch; justify-content: center; align-items: flex-start; gap: 5.89px; display: inline-flex">
              <div class="Frame14"
                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                <div class="Frame54"
                  style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 16px; display: inline-flex">
                  <div class="Frame13"
                    style="justify-content: flex-start; align-items: center; gap: 5.89px; display: flex">
                    <div class="Frame6"
                      style="padding: 11.79px; border-radius: 47.16px; border: 2.21px #05477B solid; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: flex">
                      <img alt="logo" style="width: 30.95px; height: 30.95px; position: relative" src="luggage.png" />
                    </div>
                  </div>
                  <div class="Tourist"
                    style="color: #05477B; font-size: 56px; font-family: Roboto; font-weight: 300; line-height: 67.20px; word-wrap: break-word">
                    Tourist </div>
                </div>
                <div class="Frame4"
                  style="align-self: stretch; padding-left: 80px; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: inline-flex">
                  <div class="SimplifyYourTouristTaxToday"
                    style="color: #424242; font-size: 11.05px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 19.16px; letter-spacing: 0.34px; word-wrap: break-word">
                    Simplify Your Tourist Tax </div>
                </div>
              </div>
            </div>
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>

      <div class="login100-more" style="background-image: url('login-image2.jpeg');">
      </div>
    </div>
  </div>
</div>